import { connect } from 'react-redux';
import PostUserBanner from './PostUserBanner';
import {
  editClassRoomPost,
  deleteClassRoomPost,
} from '../../../../../core/actions/classRoom/content';
import { currentUserId as getCurrentUserId } from '../../../../../core/selectors/user';
import { accessingCurrentSpaceAsStaff } from '../../../../../core/selectors/classroom';
import { isInstructor } from '../../../../utils/user';
import {
  setPostImportant,
  unsetPostImportant,
} from '../../../../../core/actions/classRoom/importantPosts';
import { openSchedulePost } from '../../../../../core/actions/classRoom/openCloseSchedulePost';

const mapStateToProps = (state, ownProps) => {
  const currentUserId = getCurrentUserId(state);
  return {
    isEducator: isInstructor(currentUserId),
    isAuthor: currentUserId === ownProps.post.user.objectId,
    isReadOnlyUser: accessingCurrentSpaceAsStaff(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleDelete: (id) => {
    dispatch(deleteClassRoomPost(id));
  },
  handleSetImportant: (postId) => {
    dispatch(setPostImportant(postId));
  },
  handleUnsetImportant: (postId) => {
    dispatch(unsetPostImportant(postId));
  },
  handleOpenSchedulePost: (postId) => dispatch(openSchedulePost(postId)),
  handlePublishPost: (postId) =>
    dispatch(
      editClassRoomPost({
        postId,
        scheduledFor: null,
      })
    ),
});

const PostUserBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostUserBanner);

export default PostUserBannerContainer;
